import HeaderTemplate from '../../../core/templates/account-navigation-wrapper.j2';
import * as AuthController from './authController';
import AccountController from './accountController';
import ErrorController from './errorController';
import ProfileModel from '../models/profileModel';
import ProfileViewModel from '../viewModels/profileViewModel';

/**
 * Controller used for /header
 */
class HeaderController extends AccountController {
    constructor() {
        super();
    }

    render(store) {
        // get session
        return new Promise((resolve, reject) => {
            AuthController.authenticate()
                // set session if retrieved from API
                .then(session => {
                    return AuthController.saveSession(session);
                })
                // get profile info from core
                .then(session => {
                    return this.getProfileFromCore(ProfileModel, store);
                })
                // save profile info to model
                .then(profileData => {
                    return super.set(ProfileModel, profileData, 'profile');
                })
                // get preferences info
                .then(profile => {
                    return super.get(ProfileModel, 'getPreferences', AuthController.get('session'), 'preferences');
                })
                // save preferences info to model
                .then(preferencesData => {
                    return super.set(ProfileModel, preferencesData, 'preferences');
                })
                // generate template
                .then(profile => {
                    return super.generateTemplate(profile, HeaderTemplate, ProfileModel, ProfileViewModel, 'Profile', store);
                })
                // attach template to DOM
                .then(template => {
                    return super.attachHeaderToDom(template);
                })
                // this cannot be removed, otherwise the world falls apart
                .then(events => {
                    return resolve(this);
                })
                // catch any errors
                .catch(error => {
                    console.error(error);
                    if (error.type === 'serviceError') {
                        ErrorController.handleErrors(error, ProfileModel, ProfileViewModel, this);
                    }
                });
        });
    }

    /**
     * Assume we've already made a call to /me for the global header...
     *
     * This grabs the data from `core` for `profile`, massages it a bit,
     * then sends it back to the promise chain to be used by `accountController.set()``
     * @param  {object} store The current state of the redux store
     * @return {object}       Profile data based on store.core, massaged into the proper format
     *                                for the `AccountController.set()` method
     */
    getProfileFromCore(model, store) {
        if(model.firstRun && typeof store.core.profile !== 'undefined' && typeof store.core.profile.name !== 'undefined') {
            const profileData = {
                data: store.core.profile,
                nonApiResponse: true
            };
            model.firstRun = false;

            return Promise.resolve(profileData);
        } else {
            // get user profile from /me
            console.log("getProfile");
            super.get(ProfileModel, 'getProfile', AuthController.get('session'), 'profile')
            .then(profileData => {
                // save profile info to model
                console.log("profileData");
                return super.set(ProfileModel, profileData, 'profile');
            });
        }
    }
}
// Create an object from the ProfileController class
const header = new HeaderController();
// Export object created from ProfileController class
export default header;
